// Tiny URL-based router. The app has only three "real" views:
//   /                         — builder
//   /admin/<32-hex-token>     — admin / Auswertung
//   /vote/<32-hex-token>      — voter
// Anything else maps to "not found".
//
// Tokens are 16-byte hex strings (32 chars) — same format the backend issues.

export type Route =
  | { kind: 'landing' }
  | { kind: 'designs' }
  | { kind: 'builder' }
  | { kind: 'basic' }
  | { kind: 'dashboard' }
  | { kind: 'admin'; token: string }
  | { kind: 'vote'; token: string }
  | { kind: 'embed'; token: string }
  | { kind: 'not-found' };

const TOKEN_RE = /^[a-f0-9]{32}$/;

export function parseRoute(pathname: string): Route {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/' || path === '') return { kind: 'landing' };
  if (path === '/designs') return { kind: 'designs' };
  if (path === '/new') return { kind: 'builder' };
  if (path === '/basic') return { kind: 'basic' };
  if (path === '/admin') return { kind: 'dashboard' };

  const adminMatch = /^\/admin\/([a-zA-Z0-9]+)$/.exec(path);
  if (adminMatch && TOKEN_RE.test(adminMatch[1])) {
    return { kind: 'admin', token: adminMatch[1] };
  }
  const voteMatch = /^\/vote\/([a-zA-Z0-9]+)$/.exec(path);
  if (voteMatch && TOKEN_RE.test(voteMatch[1])) {
    return { kind: 'vote', token: voteMatch[1] };
  }
  const embedMatch = /^\/embed\/vote\/([a-zA-Z0-9]+)$/.exec(path);
  if (embedMatch && TOKEN_RE.test(embedMatch[1])) {
    return { kind: 'embed', token: embedMatch[1] };
  }
  return { kind: 'not-found' };
}
